/**
 * Utility per gestire i festivi italiani
 */

/**
 * Verifica se una data è un festivo italiano (weekend o festivo fisso)
 * @param date Data da verificare
 * @returns true se è un festivo, false altrimenti
 */
export function isItalianHoliday(date: Date): boolean {
  // Weekend
  const weekday = date.getDay();
  if (weekday === 0 || weekday === 6) {
    return true;
  }

  const month = date.getMonth() + 1; // getMonth() restituisce 0-11
  const day = date.getDate();

  // Festivi fissi italiani
  switch (month) {
    case 1: // Gennaio
      if (day === 1) return true; // Capodanno
      if (day === 6) return true; // Epifania
      break;
    case 4: // Aprile
      if (day === 25) return true; // Liberazione
      break;
    case 5: // Maggio
      if (day === 1) return true; // Festa del Lavoro
      break;
    case 6: // Giugno
      if (day === 2) return true; // Festa della Repubblica
      break;
    case 8: // Agosto
      if (day === 15) return true; // Ferragosto
      break;
    case 11: // Novembre
      if (day === 1) return true; // Ognissanti
      break;
    case 12: // Dicembre
      if (day === 8) return true; // Immacolata Concezione
      if (day === 25) return true; // Natale
      if (day === 26) return true; // Santo Stefano
      break;
  }

  return false;
}

/**
 * Verifica se una data è un giorno lavorativo
 * @param date Data da verificare
 * @returns true se è un giorno lavorativo, false altrimenti
 */
export function isWorkingDay(date: Date): boolean {
  return !isItalianHoliday(date);
}

/**
 * Verifica se un giorno specifico è festivo (versione con parametri separati per compatibilità)
 * @param day Giorno del mese (1-31)
 * @param month Mese (1-12)
 * @param year Anno
 * @returns true se è un festivo, false altrimenti
 */
export function isHoliday(day: number, month: number, year: number): boolean {
  const date = new Date(year, month - 1, day);
  return isItalianHoliday(date);
}

